export enum PauseSceneResult {
    None = "None",
    Home = "Home",
    Restart = "Restart"
}